import { atom, useSetRecoilState, useRecoilValue } from 'recoil';

const isFreeLogin = atom({
  key: 'isFreeLogin',
  default: false,
});

export const useIsFreeLogin = () => useRecoilValue(isFreeLogin);
export const useSetIsFreeLogin = () => useSetRecoilState(isFreeLogin);
